import { ArrowLeft } from "lucide-react";
import { UnderlineLink } from "@/components/primitives/underline-link";
import { cn } from "@/lib/utils";

type SingleBreadcrumbProps = {
  href: string;
  label: string;
  className?: string;
};

export function SingleBreadcrumb({
  href,
  label,
  className,
}: SingleBreadcrumbProps) {
  return (
    <UnderlineLink
      to={href}
      className={cn(
        "text-muted-foreground hover:text-foreground text-md inline-flex items-center gap-2",
        className,
      )}
    >
      <ArrowLeft className="h-4 w-4" />
      {label}
    </UnderlineLink>
  );
}
